import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { Colors } from "@root/shared/utils";
import * as styles from "./styles.css";

export const SpView: FC = () => {
  return (
    <div className={styles.listBox}>
      <ul className={styles.list}>
        <li>
          <span className={styles.icon}>
            <Icon name="attention" fontSize="16px" color={Colors.DANGER} />
          </span>
          求職者様の報告と貴社の報告が異なる場合や、弊社で把握する内容と相違が見られる場合は、貴社と求職者様の双方に状況確認のご連絡を差し上げる場合がございます。
        </li>
      </ul>
    </div>
  );
};
